import React from "react";
import ReactApexChart from "react-apexcharts";

import getChartColorsArray from "../../Components/Common/ChartsDynamicColor";

const RevenueCharts = ({ dataColors, series,dateList }) => {
  var linechartcustomerColors = getChartColorsArray(dataColors);
 
  var options = {
    chart: {
      height: 370,
      type: "line",
      toolbar: {
        show: false,
      },
    }, 
    xaxis: { 
      type: "datetime", // 添加类型定义
      categories: dateList.map(date => new Date(date).getTime()), // 转换为时间戳
      labels: {
        formatter: function(value) {

            
          return new Date(value).toLocaleDateString(); // 本地化日期格式
        }
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
    },
    yaxis: [
      {
        seriesName: "销售额",
        title: {
          text: "金额($)",
        },
        min: 0,
        labels: {
          formatter: function(val) {
            return "$" + val.toFixed(2) + "";
          }
        }
      },
      {
        seriesName: "订单量",
        opposite: true,
        title: {
          text: "订单数量",
        },
        min: 0,
        labels: {
          formatter: function(val) {
            return val.toFixed(0);
          }
        }
      }
    ],
    grid: {
      show: true,
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
      padding: {
        top: 0,
        right: -2,
        bottom: 15,
        left: 10,
      },
    },
    legend: {
      show: true,
      horizontalAlign: "center",
      offsetX: 0,
      offsetY: -5,
      markers: {
        width: 9,
        height: 9,
        radius: 6,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 0,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "30%",
        barHeight: "70%",
      },
    },
    colors: linechartcustomerColors,
    tooltip: {
      shared: true,
      x: {
        formatter: function(val) {
          return new Date(val).toLocaleDateString();
        }
      },
      y: [
        {
          formatter: function(y) {
            return "$" + y.toFixed(2) ;
          }
        },
        {
          formatter: function(y) {
            return y.toFixed(0);
          }
        },
        {
          formatter: function(y) {
            return y.toFixed(0);
          }
        }
      ]
    }
  };
  return (
    <React.Fragment>
      <ReactApexChart dir="ltr"
        options={options}
        series={series}
        type="line"
        height="370"
        className="apex-charts"
      />
    </React.Fragment>
  );
};

const StoreVisitsCharts = ({ dataColors }) => {
  var chartDonutBasicColors = getChartColorsArray(dataColors);
  const series = [44, 55, 41, 17, 15];
  var options = {
    labels: ["Direct", "Social", "Email", "Other", "Referrals"],
    chart: {
      height: 333,
      type: "donut",
    },
    legend: {
      position: "bottom",
    },
    stroke: {
      show: false,
    },
    dataLabels: {
      dropShadow: {
        enabled: false,
      },
    },
    colors: chartDonutBasicColors,
  };
  return (
    <React.Fragment>
      <ReactApexChart dir="ltr"
        options={options}
        series={series}
        type="donut"
        height="333"
        className="apex-charts"
      />
    </React.Fragment>
  );
};

export { RevenueCharts, StoreVisitsCharts };
